// @flow
export { default } from './PartnerCard';



// WEBPACK FOOTER //
// ./src/components/common/PartnerCard/index.js